import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

const TableRedirectionLink = ({ children, redirectTo , state }) => {

    const navigate = useNavigate();
    const loactionState = useLocation();

  return (
    <div onClick={() => navigate(redirectTo, { state: {...loactionState.state, ...state } })} className='cursor-pointer'>{children}</div>
  )
}

export default TableRedirectionLink